// Helpers cho camera (chụp ảnh) và tải thư viện quét QR (jsQR qua CDN)

// Mở camera trả về MediaStream. Ưu tiên camera sau trên mobile.
export const startCameraStream = async (facingMode = "environment") => {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error("Trình duyệt không hỗ trợ truy cập camera");
  }
  try {
    return await navigator.mediaDevices.getUserMedia({
      video: { facingMode: { ideal: facingMode } },
      audio: false,
    });
  } catch (e) {
    // fallback: camera bất kỳ
    return navigator.mediaDevices.getUserMedia({ video: true, audio: false });
  }
};

export const stopCameraStream = (stream) => {
  try {
    stream?.getTracks?.().forEach((t) => t.stop());
  } catch {
    /* noop */
  }
};

// Chụp 1 khung hình từ <video> -> File (jpeg)
export const captureFrameToFile = (video, name = "checkin.jpg") =>
  new Promise((resolve, reject) => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth || 720;
      canvas.height = video.videoHeight || 960;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (blob) => {
          if (!blob) return reject(new Error("Không chụp được ảnh"));
          resolve(new File([blob], name, { type: "image/jpeg" }));
        },
        "image/jpeg",
        0.85
      );
    } catch (e) {
      reject(e);
    }
  });

// Tải jsQR từ CDN (chỉ tải 1 lần). Trả về hàm jsQR.
let jsQrPromise = null;
export const loadJsQR = () => {
  if (window.jsQR) return Promise.resolve(window.jsQR);
  if (jsQrPromise) return jsQrPromise;
  jsQrPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js";
    script.async = true;
    script.onload = () =>
      window.jsQR
        ? resolve(window.jsQR)
        : reject(new Error("Không tải được thư viện quét QR"));
    script.onerror = () =>
      reject(new Error("Không tải được thư viện quét QR (kiểm tra kết nối mạng)"));
    document.body.appendChild(script);
  });
  return jsQrPromise;
};
